import http from 'helpers/APIHelper';
import { getSessionByKey } from 'helpers';
import { suffixPending, suffixFulfilled, suffixRejected } from 'actions';

export const CIRB_ACTIONS = {
  GET_EVENT_DOCS: '@protocol/version/getEventDocs'
};

export const getEventDocs = (token, loggerInfo, id, eventId) => dispatch => {
  dispatch({
    type: CIRB_ACTIONS.GET_EVENT_DOCS + suffixPending
  });
  http
    .postWithToken(
      `protocol-data-service/${
        getSessionByKey('prt_url_ver')
      }/protocols/number/${id}/cirbsiteevents/${eventId}/documents`,
      token,
      loggerInfo
    )
    .subscribe(
      resp => {
        dispatch({
          type: CIRB_ACTIONS.GET_EVENT_DOCS + suffixFulfilled,
          payload: resp.response
        });
      },
      error => {
        dispatch({
          type: CIRB_ACTIONS.GET_EVENT_DOCS + suffixRejected,
          payload: error
        });
      }
    );
};
